import React from 'react'
import PropTypes from 'prop-types'

const EmailIcon = (props) => {
  const {
    color = '#183560',
    classes = 'w-20',
    revert = false,
    notBackground = false,
    backgroundColor = '#ffffff',
  } = props

  const colorIcon = revert ? '#ffffff' : color
  const background = notBackground ? 'none' : revert ? color : backgroundColor

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <circle cx="10" cy="10" r="10" fill={background} />
      <path
        d="M14.8 6H5.2C4.54 6 4.006 6.50625 4.006 7.125L4 13.875C4 14.4937 4.54 15 5.2 15H14.8C15.46 15 16 14.4937 16 13.875V7.125C16 6.50625 15.46 6 14.8 6ZM14.56 8.39062L10.318 10.8769C10.126 10.9894 9.874 10.9894 9.682 10.8769L5.44 8.39062C5.29 8.30063 5.2 8.14875 5.2 7.98563C5.2 7.60875 5.638 7.38375 5.98 7.58062L10 9.9375L14.02 7.58062C14.362 7.38375 14.8 7.60875 14.8 7.98563C14.8 8.14875 14.71 8.30063 14.56 8.39062Z"
        fill={colorIcon}
      />
    </svg>
  )
}

EmailIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
  revert: PropTypes.bool,
  notBackground: PropTypes.bool,
  backgroundColor: PropTypes.string,
}

export default React.memo(EmailIcon)
